import {ChangeDetectionStrategy, Component, contentChild, input, TemplateRef} from '@angular/core';
import {NgTemplateOutlet} from '@angular/common';
import {NgxSmartModalComponent} from 'ngx-smart-modal';

@Component({
  selector: 'ms-dialog',
  templateUrl: './dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgxSmartModalComponent, NgTemplateOutlet],
})
export class DialogComponent {
  readonly identifier = input.required<string>();
  readonly customClass = input<string>();
  readonly hideDelay = input<number>(0);

  readonly dialogTemplate = contentChild(TemplateRef);
}
